import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import Form from "@covertree/ui/forms/Form";
import FormCodeField from "@covertree/ui/forms/FormCodeField";
import SubmitButton from "@covertree/ui/buttons/SubmitButton";

import {
  type ConfirmSignInFormData,
  defaultValues,
  validationSchema,
} from "./form";

interface Props {
  submit: (values: ConfirmSignInFormData) => void;
  resendCode?: () => void;
}

export const ConfirmSignInForm = ({ submit, resendCode }: Props) => {
  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm({
    defaultValues,
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  return (
    <Box mt={4}>
      <Form onSubmit={handleSubmit(submit)}>
        <Grid container>
          <Grid item xs={12} display="flex" justifyContent="center">
            <FormCodeField
              id="code-field"
              name="code"
              disabled={isSubmitting}
              control={control}
            />
          </Grid>

          <SubmitButton
            loading={isSubmitting}
            disabled={!isValid || isSubmitting}>
            Sign In
          </SubmitButton>
        </Grid>
      </Form>
      {resendCode ? (
        <Box mt={4}>
          <Grid display="flex" justifyContent="center">
            <Link component={ButtonBase} underline="hover" onClick={resendCode}>
              <Typography>Resend the code</Typography>
            </Link>
          </Grid>
        </Box>
      ) : null}
    </Box>
  );
};

export default ConfirmSignInForm;
